import React from 'react';

import Card from 'react-bootstrap/Card';

import Page from 'components/page/page.component';

import defaultProfileImg from 'assets/images/default-profile.jpg';

//  headshot images
import AnnettePhillipsImgSrc from 'assets/headshots/Phillips.jpg';
import BradKingImgSrc from 'assets/headshots/King.jpg';
import DebWiseImgSrc from 'assets/headshots/Wise.jpg';
import HeatherWilliamsImgSrc from 'assets/headshots/Williams.jpg';
import JamesLoweImgSrc from 'assets/headshots/Lowe.jpg';
import JasonDonatiImgSrc from 'assets/headshots/Donati.jpg';
import JohnWestHeadshotSrc from 'assets/headshots/West.jpg';
import MartaMoodyImgSrc from 'assets/headshots/Moody.jpg';
import MelanieWhiteImgSrc from 'assets/headshots/White.jpg';

import './style.css';

const RoleSection = ({ about, title, dept, org }) => {
    return (
        <div className="director-role">
            {title && <div className="director-role-title">{title}</div>}
            {dept && <div>{dept}</div>}
            {org && <div className="director-role-org">{org}</div>}
            {about && (
                <div className="director-about mt-3">
                    <small>{about}</small>
                </div>
            )}
        </div>
    );
};

const DirectorCard = ({ imgSrc, name, title, role, other, appointedBy }) => {
    return (
        <Card>
            <Card.Img variant="top" src={imgSrc} />
            <Card.Header>
                <div>
                    {name}, {title}
                </div>
                <div>
                    <small>Appointed by {appointedBy}</small>
                </div>
            </Card.Header>
            <Card.Body>
                <div>{role}</div>
                {other && (
                    <>
                        <div className="other-activities-label">Other Professional Associations</div>
                        <div className="other-activities">
                            <small>{other}</small>
                        </div>
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

const BoardOfDirectors = () => {
    return (
        <Page
            className="board-of-directors"
            pageContentStyle={{ justifyContent: 'center' }}
            variant="row-flex-wrap"
            heroTitle="Board of Directors"
            heroSize="small"
        >
            <DirectorCard
                name="John West, Ph.D."
                imgSrc={JohnWestHeadshotSrc || defaultProfileImg}
                title="Chair"
                appointedBy="Mayor"
                role={<RoleSection title="Assistant Professor of Urban Planning" org="Ball State University" />}
            />
            <DirectorCard
                name="Brad King"
                imgSrc={BradKingImgSrc || defaultProfileImg}
                title="Vice-Chair"
                appointedBy="City Council"
                other="President of the Old West End Neighborhood Association"
                role={<RoleSection title="Planner" org="City of Muncie" />}
            />
            <DirectorCard
                name="James Lowe"
                imgSrc={JamesLoweImgSrc || defaultProfileImg}
                appointedBy="City Council"
                role={
                    <RoleSection
                        title="Associate Vice President"
                        dept="Facilities Planning and Management"
                        org="Ball State University"
                    />
                }
            />
            <DirectorCard
                name="Heather Williams"
                imgSrc={HeatherWilliamsImgSrc || defaultProfileImg}
                title="Secretary"
                appointedBy="Muncie Land Bank Board of Directors"
                other="President, ecoREHAB of Muncie, Inc.; Secretary and Task Force 2 Chair, Muncie Action Plan, Inc.; President, Riverside-Normal City Neighborhood Association"
                role={
                    <>
                        <RoleSection
                            title="Associate Director"
                            dept="Office of Community Engagement"
                            org="Ball State University"
                        />
                        <RoleSection
                            title="Program Director"
                            dept="Building Better Neighborhoods"
                            org="Ball State University"
                        />
                    </>
                }
            />
            <DirectorCard
                name="Jason Donati"
                imgSrc={JasonDonatiImgSrc || defaultProfileImg}
                title=""
                appointedBy="Mayor"
                other="Board Member, The Cardinal Greenway; Board Member, The Muncie Action Plan; Council Member, Muncie Community Schools Community Engagement Council; Council Member, Delaware County Emergency Management Advisory Council"
                role={<RoleSection title="Stormwater &amp; Recycling Educator" org="Muncie Sanitary District" />}
            />
            <DirectorCard
                name="Marta Moody"
                imgSrc={MartaMoodyImgSrc || defaultProfileImg}
                title=""
                appointedBy="City Council"
                other="Cardinal Greenway, Inc.; Muncie Action Plan (MAP); Community Enhancement Projects, Inc. (CEP); East Central Indiana Regional Planning District (ECIRPD); Central Indiana Regional Transportation Authority (CIRTA)"
                role={<RoleSection title="Executive Director" org="DMMPC" />}
            />
            <DirectorCard
                name="Annette Phillips"
                imgSrc={AnnettePhillipsImgSrc || defaultProfileImg}
                title=""
                appointedBy="Muncie Land Bank Board of Directors"
                other="Flagship Enterprise Capital Board Member"
                role={
                    <RoleSection
                        title="Community Development Director"
                        dept="Indiana Office"
                        org="PathStone Corporation"
                    />
                }
            />
            <DirectorCard
                name="Melanie White"
                imgSrc={MelanieWhiteImgSrc || defaultProfileImg}
                title="Treasurer"
                appointedBy="Muncie Land Bank Board of Directors"
                other="MEIAR - Governmental Affairs Committee"
                role={
                    <RoleSection
                        title="Associate Broker, Sales Manager"
                        org="Berkshire Hathaway HomeServices Indiana Realty"
                    />
                }
            />
            <DirectorCard
                name="Deb Wise"
                imgSrc={DebWiseImgSrc || defaultProfileImg}
                title=""
                appointedBy="Mayor"
                other="Nassau Swim Club, Manage HOA's at Eagle Branch Villas and Woodland Gardens, Member of Muncie Arts Cultural Council, Village Alliance"
                role={<RoleSection title="Property Manager, Managing Broker and Owner" dept="" org="SPS" />}
            />
        </Page>
    );
};

export default BoardOfDirectors;
